import { Component, OnInit } from '@angular/core';
import { SideNavBarVisibilityService } from 'src/app/services/side-nav-bar-visibility.service';
import { ThemeService } from 'src/app/theme/theme-service.service';

@Component({
    selector: 'app-reset-password-contact',
    templateUrl: './reset-password-contact.component.html',
    styleUrls: ['./reset-password-contact.component.scss'],
    standalone: false
})
export class ResetPasswordContactComponent implements OnInit {
  constructor(public sideNavBarVisibilityService: SideNavBarVisibilityService,
    public themeService: ThemeService) { }

  ngOnInit() {
    this.sideNavBarVisibilityService.hideSideNav = true;
  }

}
